import { EditorElementTypes } from '@src/components/sco/RichMarkdownInput/components/Element'
import { EditorProps } from '@src/components/sco/RichMarkdownInput/utilities/EditorProps'
import { Editor, Element as SlateElement, Node, Range, Transforms } from 'slate'

export const LIST_TYPES = ['ol_list', 'ul_list']

export const isBlockActive = (editor: EditorProps, format: string) => {
  const nodeGen = Editor.nodes(editor, {
    // @ts-ignore
    match: n => !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format,
  })

  const node = nodeGen.next()
  while (!node.done) {
    return true
  }
  return false
}

// This is a global variable to store the openLinkModal function
// It will be set when the component using the context is mounted
let globalOpenLinkModal:
  | ((
      initialUrl: string,
      initialLabel: string,
      title: string,
      onSubmit: (url: string, label?: string) => void,
      onRemove?: () => void
    ) => void)
  | null = null

// Function to set the global openLinkModal function
export const setGlobalOpenLinkModal = (
  openLinkModal:
    | ((
        initialUrl: string,
        initialLabel: string,
        title: string,
        onSubmit: (url: string, label?: string) => void,
        onRemove?: () => void
      ) => void)
    | null
) => {
  globalOpenLinkModal = openLinkModal
}

export const showLinkModal = (
  initialUrl: string = '',
  initialLabel: string = '',
  title: string,
  onSubmit: (url: string, label?: string) => void,
  onRemove?: () => void
) => {
  // Skip showing the modal for mention links
  if (initialUrl.startsWith('mention:')) {
    return
  }

  if (globalOpenLinkModal) {
    globalOpenLinkModal(initialUrl, initialLabel, title, onSubmit, onRemove)
  } else {
    console.error('LinkModal context not initialized. Make sure to use LinkModalProvider.')
  }
}

export const injectBlock = (editor: EditorProps, format: string) => {
  if (format === EditorElementTypes.LINK) {
    // Check if the current selection is a link
    let initialUrl = ''
    let initialLabel = ''
    let linkNodeEntry = null
    const { selection } = editor

    if (selection) {
      // Try to find a link node at the current selection
      const nodeEntries = Editor.nodes(editor, {
        match: n =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          // @ts-ignore
          (n as { type: string }).type === EditorElementTypes.LINK,
        at: selection,
      })

      // Get the first entry if it exists
      const firstEntry = nodeEntries.next()
      if (!firstEntry.done) {
        linkNodeEntry = firstEntry.value
        initialUrl = linkNodeEntry[0].url || ''

        // Get the text content of the link for the label
        const linkText = Node.string(linkNodeEntry[0])
        initialLabel = linkText || ''
      }
    }

    // Get the selected text if no link is found
    if (!linkNodeEntry && selection && !Range.isCollapsed(selection)) {
      const selectedText = Editor.string(editor, selection)
      initialLabel = selectedText
    }

    showLinkModal(
      initialUrl,
      initialLabel,
      'Enter Link Details',
      (url, label) => {
        // Skip inserting mention links
        if (url.startsWith('mention:')) {
          return
        }

        // Only insert link if URL is not empty to prevent link removal
        if (url && editor.insertLink) {
          // If we have a label, we need to modify how the link is inserted
          if (label && label !== url) {
            // If selection is collapsed, insert the label text and then wrap it in a link
            if (selection && Range.isCollapsed(selection)) {
              // Get the current point before inserting text
              const point = selection.anchor

              // Insert the label text
              Transforms.insertText(editor, label)

              // Calculate the start and end points for the inserted text
              const start = { path: point.path, offset: point.offset }
              const end = { path: point.path, offset: point.offset + label.length }

              // Select the inserted text
              Transforms.select(editor, { anchor: start, focus: end })
            }

            // Now wrap the selection in a link
            Transforms.wrapNodes(
              editor,
              // @ts-ignore
              { type: EditorElementTypes.LINK, url, children: [] },
              { split: true }
            )
          } else {
            // Use the default insertLink with both URL and label
            // @ts-ignore
            editor.insertLink(url, label)
          }
        }
      },
      linkNodeEntry
        ? () => {
            // Remove link functionality
            if (linkNodeEntry) {
              Transforms.unwrapNodes(editor, {
                at: linkNodeEntry[1],
              })
            }
          }
        : undefined
    )
    return
  }
  alert(`Inject Block TBD: ${format}`)
}
export const injectMark = (editor: EditorProps, format: string) => {
  alert(`Inject Mark TBD: ${format}`)
}

export const toggleBlock = (editor: EditorProps, format: string) => {
  const isActive = isBlockActive(editor, format)
  const isList = LIST_TYPES.includes(format)

  Transforms.unwrapNodes(editor, {
    match: n =>
      // @ts-ignore
      LIST_TYPES.includes((!Editor.isEditor(n) && SlateElement.isElement(n) && n.type) as string),
    split: true,
  })

  const newProperties: Partial<SlateElement> = {
    // @ts-ignore
    type: isActive ? 'paragraph' : isList ? 'list_item' : format,
  }
  Transforms.setNodes(editor, newProperties)

  if (!isActive && isList) {
    const block = { type: format, children: [] }
    Transforms.wrapNodes(editor, block)
  }
}
